import { FilterFn } from '@tanstack/react-table';

export const arrIncludesArrayItem: FilterFn<unknown> = (
  row,
  columnId,
  filterValues,
) => {
  // filterValues must be an array (multi-select)
  if (!Array.isArray(filterValues) || filterValues.length === 0) return false;

  const cellValue = row.getValue<string | number>(columnId);

  return filterValues.includes(cellValue);
};

export const numberInRange: FilterFn<unknown> = (
  row,
  columnId,
  filterValues,
) => {
  if (!filterValues) return true;

  const [min, max] = filterValues;
  const value = row.getValue<number>(columnId);

  if (typeof min === 'number' && value < min) {
    return false;
  }

  if (typeof max === 'number' && value > max) {
    return false;
  }

  return true;
};
